import { render, staticRenderFns } from "./TicketReplyTemplateDataManagement.vue?vue&type=template&id=45003447&scoped=true&"
import script from "./TicketReplyTemplateDataManagement.vue?vue&type=script&lang=js&"
export * from "./TicketReplyTemplateDataManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45003447",
  null
  
)

export default component.exports